import s from './TitleImageSection.module.scss';
import {TTitleImageSectionProps} from "@/app/[locale]/common/components/TitleImageSection/types";
import {Title} from "@/app/[locale]/common/components/Title/Title";
import React from "react";
import Image from "next/image";

export const TitleImageSection = ({ title, image }: TTitleImageSectionProps) => {
    return (
        <>
            <Title title={title}/>
            <div className={s.imageContainer}>
                <Image src={image} alt={title}/>
            </div>
        </>
    );
};